import { AdditionalProductFlowPagePreview } from '@components/additionalProducts/AdditionalProductFlowPagePreview';
import { Heading2 } from '@components/utils/text';
import { StyledProps } from '@emotion/react';
import styled from '@emotion/styled';
import { VStack } from '@lib/uikit';
import { FC } from 'react';

import { useFlowPage } from '../contexts/FlowPageContext';
import { Alignment } from '../types';
import { FlowPageBackgroundImage } from './FlowPageBackgroundImage';
import { FlowPageDescription } from './FlowPageDescription';
import { FlowPageEscape } from './FlowPageEscape';
import { FlowPageFooter } from './FlowPageFooter';
import { isSellFlowPage } from '../utils/validators';



const Body = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: end;
    gap: ${({ theme }) => theme.spacing.xl};
    height: 100%;
`;

const Heading = styled(Heading2)<StyledProps<{ textAlign: Alignment }>>`
    text-align: ${({ textAlign }) => textAlign};
    color: ${({ theme }) => theme.palette.common.white};
`;

const CenteredVertically = styled.div`
    flex-basis: 50%;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.sm};
`;

export const FlowPage: FC = () => {
    const { title, headingAlignment, flowPage } = useFlowPage();

    return (
        <VStack
            height='100%'
            justifyContent='space-between'
            spacing='xl'
            paddingBlock='md'
            paddingInline='md'
        >
            <FlowPageEscape />
            <FlowPageBackgroundImage image={flowPage.Image} />
            <Body>
                <CenteredVertically>
                    <VStack spacing='xl'>
                        <Heading textAlign={headingAlignment}>{title}</Heading>
                    </VStack>
                    <FlowPageDescription />
                    {isSellFlowPage(flowPage) && (
                        <AdditionalProductFlowPagePreview
                            additionalProduct={
                                flowPage.AdditionalProduct.Additional_product
                            }
                        />
                    )}
                </CenteredVertically>
            </Body>
            <FlowPageFooter />
        </VStack>
    );
};
